const data = [
    { id: 1, name: "Habilitação de crédito retardatária" },
    { id: 2, name: "Revisão de Crédito de crédito retardatária" },
    { id: 3, name: "Revisão de Crédito de crédito tempestiva" }
];
  
export default [...data];
  